export enum AuthClaimsEnum {
	IDENTITYID = 'http://www.dickssportinggoods.com/identityId',
	SCORECARD = 'http://www.dickssportinggoods.com/scorecardnumber',
}
